import * as Actions from 'app/store/actions/departments';

const initialState = {
  data: []
};

const departmentsReducer = function (state = initialState, action) {
  switch (action.type) {
    case Actions.GET_DEPARTMENTS: {
      return {
        ...state,
        data: action.payload
      };
    }
    case Actions.GET_DEPARTMENTS_FOR_A_SPECIFIC_BRAND: {
      return {
        ...state,
        data: action.payload
      };
    }
    default: {
      return state;
    }
  }
};

export default departmentsReducer;
